import { render, staticRenderFns } from "./sub2Page.vue?vue&type=template&id=b0ebc8f6&scoped=true"
import script from "./sub2Page.vue?vue&type=script&lang=js"
export * from "./sub2Page.vue?vue&type=script&lang=js"
import style0 from "./sub2Page.vue?vue&type=style&index=0&id=b0ebc8f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ebc8f6",
  null
  
)

export default component.exports